// extracted by mini-css-extract-plugin
module.exports = {"separator":"PageToolbarSeparator-separator-2Aqbm"};